import { Divider, IconButton, Menu } from '@material-ui/core'
import { MoreVertOutlined } from '@material-ui/icons'
import { BoMItemType } from 'model/Project/BoMItemRow'
import { useRef, useState } from 'react'
import { AggregateLevel } from 'services/APIs/InternalAPI/internal-api.contracts'
import { AssemblySimplificationMenuItem } from './MenuItems/AssemblySimplificationMenuItem'
import { DeleteMenuItem } from './MenuItems/DeleteMenuItem'
import { DownloadBomItemFilesMenuItem } from './MenuItems/DownloadBomItemFilesMenuItem'
import { EventLogMenuItem } from './MenuItems/EventLogMenuItem'
import { OpenDetailsSidePanelButton } from './MenuItems/OpenDetailsSidePanelButton'
import { OpenOnErpMenuItem } from './MenuItems/OpenOnErpMenuItem'
import { RegressionTestMenuItem } from './MenuItems/RegressionTestMenuItem'
import { ReportRecognitionIssuesMenuItem } from './MenuItems/ReportRecognitionIssuesMenuItem'

export const AssemblyHeaderMenuButton = ({
  bomItemId,
}: {
  bomItemId: string
}) => {
  const [open, setOpen] = useState(false)
  const buttonRef = useRef(undefined)

  const handleClose = () => setOpen(false)

  return (
    <>
      <IconButton
        onClick={() => setOpen(true)}
        ref={buttonRef}
        size="small"
        color="inherit"
      >
        <MoreVertOutlined />
      </IconButton>
      <Menu
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={buttonRef.current}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'top',
        }}
      >
        <span>
          <OpenDetailsSidePanelButton
            bomItemId={bomItemId}
            bomItemType={BoMItemType.assemblyHeader}
            onClose={handleClose}
          />
          <OpenOnErpMenuItem bomItemId={bomItemId} onClose={handleClose} />
          <AssemblySimplificationMenuItem
            bomItemId={bomItemId}
            onClose={handleClose}
          />
          <DownloadBomItemFilesMenuItem
            bomItemId={bomItemId}
            bomItemType={'assembly'}
            onClose={handleClose}
          />
          <Divider />
          <DeleteMenuItem bomItemId={bomItemId} onClose={handleClose} />
          <Divider />
          <ReportRecognitionIssuesMenuItem
            bomItemId={bomItemId}
            onClose={handleClose}
            aggregateLevel={AggregateLevel.Assembly}
          />
          <RegressionTestMenuItem bomItemId={bomItemId} onClose={handleClose} />
          <Divider />
          <EventLogMenuItem
            bomItemType={BoMItemType.assemblyHeader}
            bomItemId={bomItemId}
            onClose={handleClose}
          />
        </span>
      </Menu>
    </>
  )
}
